import { render, staticRenderFns } from "./PortalResultadosSolicitante.vue?vue&type=template&id=d5272762&"
import script from "./PortalResultadosSolicitante.vue?vue&type=script&lang=js&"
export * from "./PortalResultadosSolicitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports